import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router'
import Header from '../menu/Header'
import Page from './Page'
import { compact } from 'lodash'
import { Typography } from '@mui/material'


const TabbedPage = ({ tabs, containerSx }) => {
  
  const navigate = useNavigate()
  const location = useLocation()
  
  const selectedTab = useMemo(() => tabs.find(t => t.key === location.pathname.split('/').pop()), [tabs, location.path])
  console.log('selectedTab', selectedTab)
  
  return (
    <Page
      withTopBarAndMenu
      containerSx={containerSx}
      title={<Typography color='inherit' variant='h5' component='h1' display='inline-flex' ml={{ xs: 1, md: 2 }} mt={{ xs: 0, md: 1 }} sx={{ verticalAlign: 'middle' }}>
        {selectedTab?.title || selectedTab?.label}
      </Typography>}
    >
      <Routes>
        {compact(tabs).map(tab =>
          <Route
            key={'route' + tab.key}
            path={tab.route}
            element={<>
              <Header
                setValue={val => navigate('../' + val, { relative: 'path' })}
                value={tab.key}
                tabs={compact(tabs)}
              >
                {tab.headerContent || null}
              </Header>
              {tab.content}
            </>}
          />,
        )}
        <Route path='/' element={<Navigate replace to={'../' + tabs[0].route} />} />
      </Routes>
    </Page>
  )
}

TabbedPage.propTypes = {
  tabs: PropTypes.array.isRequired,
  containerSx: PropTypes.object,
}

export default TabbedPage
